import { useResponsiveModal } from 'src/components/Modals/ResponsiveModal/ResponsiveModalContext';
import { cj } from 'src/utils/classNames';

interface Props {
	title: string;
	description: string;
	isSelected: boolean;
	handleSelect: () => void;
}

export default function TpSlTriggerPercentBasisOption({
	isSelected,
	handleSelect,
	title,
	description,
}: Props) {
	const { close } = useResponsiveModal();

	const handleClick = () => {
		handleSelect();
		close();
	};

	return (
		<button
			className={cj(
				'flex w-full flex-col gap-y-lg rounded-sm p-lg text-left',
				'border text-text-default hover:border-button-primary-bg',
				isSelected
					? 'border-button-primary-bg bg-button-selector'
					: 'border border-input-border bg-input-bg'
			)}
			onClick={handleClick}
		>
			<p className="typo-t2">{title}</p>

			<p
				className={cj(
					'typo-b4 transition-colors',
					isSelected ? 'text-text-default' : 'text-text-secondary'
				)}
			>
				{description}
			</p>
		</button>
	);
}
